import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Typography, Modal, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { LegacyMarket, Market } from '../../models/market/LegacyMarket';
import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router-dom for navigation
import { mymarketDelete, myMarketsList } from '../../hooks/actions/market';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { GREEN_LOGO, GREEN_MAIN, WHITE } from '../../theme/colors';
import { useWaiter } from '../../hooks/waiter/WaiterProvider';
import AlertDeleteModal from './AlertDeleteModal';
import { useUserContext } from '../../hooks/auth/UserProvider';

const MarketList: React.FC = () => {
  const [legacyMarkets, setLegacyMarkets] = useState<LegacyMarket[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedMarket, setSelectedMarket] = useState<Market | null>(null);
  const navigate = useNavigate(); // Hook for navigation
  const {t} = useTranslationContext();
  const {setWaiterView} = useWaiter();
  const {isForbidden} = useUserContext();

  useEffect(() => {
    if(isForbidden){
      navigate('/');
    }
  }, [isForbidden]);

  // Funzione per ottenere i dati
  useEffect(() => {
    setWaiterView(true);
    myMarketsList().then((resp) => {
        setLegacyMarkets(resp);
        
        if(!resp[0]?.markets || resp[0]?.markets.length === 0){
          handleAddMarket();
        }
    }).catch(error => {
      // Gestisci eventuali errori qui
    });
     setWaiterView(false);
  }, []);

  const handleEdit = (market: Market) => {
    navigate(`/activity/${market.id}`);
  };

  const handleDelete = (market: Market) => {
    setSelectedMarket(market);
    setDeleteModalOpen(true); // Apri il modal di conferma
  };

  const handleCloseModal = () => {
    setDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    if (selectedMarket) {
      setWaiterView(true);
      mymarketDelete(selectedMarket.id).then((resp) => {
        setLegacyMarkets(resp);
        if(!resp[0]?.markets || resp[0]?.markets.length === 0){
          handleAddMarket();
        }
      }).catch(error => {
        // Gestisci eventuali errori qui
      });
      setDeleteModalOpen(false);
      setWaiterView(false);
    }
  };

  const handleAddMarket = () => {
    navigate('/activity');
  };

  return (
    <Box paddingTop="60px">
      {/* <Grid container xs={12}> */}
      {
      legacyMarkets && legacyMarkets.length > 0 ? legacyMarkets.map((legacyMarket) => (
        // <Grid item xs={12} sm={8} md={3}>
          <Box key={legacyMarket.nationSedeLegale} sx={{ mb: 4 }}>
            <Typography variant="h6">
              {legacyMarket.nationSedeLegale}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
              {legacyMarket.markets.map((market) => (
                <Box
                  sx={{display:'flex', flexDirection:'row'}}
                >
                  <Box
                    key={market.marketName}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      borderBottom: '1px solid #ccc',
                      padding: '10px',
                      flex:1,
                      overflowX: 'auto',  // Enable horizontal scrolling
                      maxWidth: 'calc(100% - 100px)',  // Adjust width to ensure it doesn’t overflow due to the buttons
                      whiteSpace: 'nowrap',  // Prevent text wrapping
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection:'row'}}>
                      <Typography><strong>{market.marketName}</strong></Typography>
                      <Box sx={{display:'flex', flexDirection:'column', paddingLeft:5}}>
                        <Typography
                          sx={{
                            textAlign:'start'
                          }}
                        >{market.marketAddress}, {market.marketCity}, {market.marketCAP}, {market.marketProvince}</Typography>
                        <Typography
                        sx={{
                          fontSize:'0.75rem',
                          textAlign:'start'
                        }}>{market.description}</Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minWidth: '100px' }}
                  >
                    <IconButton onClick={() => handleEdit(market)} sx={{ color: 'green' }}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(market)} sx={{ color: 'red' }}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        // </Grid>
      )):
        // <Grid item xs={12} sm={8} md={3}>
          <Box justifyItems='center'>
            <Grid container xs={12} md={4} spacing={0} paddingBottom='100px' paddingTop='100px'>
              <Typography
                variant="h5"
                component="h1"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: GREEN_MAIN
                }}
              >
                {t("Non hai ancora aggiunto nessuna attività economica")}
            </Typography>
            </Grid>
          </Box>
        // </Grid>
      }
      {/* </Grid> */}

      <Grid container justifyContent="center" alignItems="center" paddingTop="100px">
        <Grid item xs={'auto'}>
          <Button variant="contained" color="info" onClick={handleAddMarket} sx={{
            margin:"10px 0 0 0",
            height: '35px',
            color:WHITE,
            backgroundColor: GREEN_LOGO,
            "&:hover": { backgroundColor: "darkgreen" },
            border: "1px solid " + GREEN_LOGO,
            textTransform: 'none',
          }}>
            {t("Aggiungi nuova attività economica")}
          </Button>
        </Grid>
      </Grid>

      <AlertDeleteModal
        open={deleteModalOpen}
        onClose={handleCloseModal}
        onDelete={confirmDelete}
        market={selectedMarket}
      />

    </Box>
  );
};

export default MarketList;
